import LegalPage from "../../components/LegalPage";

export default function DataPrivacy() {
  return (
    <LegalPage
      badge="Legal"
      title="Data Privacy"
      lastUpdated="Feb 1, 2026"
      sections={[
        {
          heading: "Our Data Privacy Principles",
          paragraphs: ["Beyond compliance, we hold ourselves to four principles:"],
          bullets: [
            "Minimum collection — we collect only what we need to operate the Service.",
            "Purpose limitation — your data is used only for the reasons stated when collected.",
            "Transparency — you can see, export, and delete your data at any time.",
            "Security by default — encryption, access control, and audit are non-negotiable.",
          ],
        },
        {
          heading: "GDPR Compliance",
          paragraphs: ["Brivo complies with the EU General Data Protection Regulation. We act as a Data Processor when handling your customers' data, and as a Data Controller for your account information. A Data Processing Agreement (DPA) is available on request."],
        },
        {
          heading: "CCPA / CPRA Compliance",
          paragraphs: ["California residents have specific rights under the CCPA/CPRA, including the right to know, delete, correct, and opt out of the sale of personal information. We do not sell personal information."],
        },
        {
          heading: "Data Residency",
          paragraphs: ["By default, data is stored in the United States. Enterprise customers can request EU or APAC data residency for an additional fee."],
        },
        {
          heading: "Sub-Processors",
          paragraphs: ["We use carefully vetted sub-processors to operate Brivo:"],
          bullets: [
            "AWS (cloud hosting)",
            "Stripe (payment processing)",
            "MongoDB Atlas (database)",
            "Postmark (transactional email)",
            "Twilio (SMS)",
            "PostHog (product analytics)",
          ],
        },
        {
          heading: "Data Breach Notification",
          paragraphs: ["In the unlikely event of a data breach affecting your information, Brivo will notify you within 72 hours of discovery, in accordance with applicable law. Notifications include the nature of the breach, data affected, and remediation steps."],
        },
        {
          heading: "Your Data Rights — Quick Reference",
          paragraphs: [],
          bullets: [
            "Access: Request a copy of all data we hold about you.",
            "Rectification: Correct inaccurate or incomplete data.",
            "Erasure: Request deletion of your data.",
            "Portability: Export your data in a machine-readable format.",
            "Objection: Object to specific processing activities.",
            "Restriction: Request that processing be temporarily paused.",
          ],
        },
        {
          heading: "How to Exercise Your Rights",
          paragraphs: ["Email privacy@brivo.app with your request. We verify your identity and respond within 30 days. There is no fee for reasonable requests."],
        },
      ]}
    />
  );
}
